import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SellingProviderId, EbaySiteId } from '@findmystuff/shared';

interface SellingStore {
  // Selected selling provider
  selectedProvider: SellingProviderId;
  setSelectedProvider: (provider: SellingProviderId) => void;

  // eBay-specific: Selected marketplace for new listings
  selectedEbaySiteId: EbaySiteId;
  setSelectedEbaySiteId: (siteId: EbaySiteId) => void;

  // Sell modal state
  sellModalItemId: string | null;
  openSellModal: (itemId: string) => void;
  closeSellModal: () => void;
}

export const useSellingStore = create<SellingStore>()(
  persist(
    (set) => ({
      selectedProvider: 'ebay',
      setSelectedProvider: (provider) => set({ selectedProvider: provider }),

      selectedEbaySiteId: 'EBAY_US',
      setSelectedEbaySiteId: (siteId) => set({ selectedEbaySiteId: siteId }),

      sellModalItemId: null,
      openSellModal: (itemId) => set({ sellModalItemId: itemId }),
      closeSellModal: () => set({ sellModalItemId: null }),
    }),
    {
      name: 'selling-preferences',
      partialize: (state) => ({
        selectedProvider: state.selectedProvider,
        selectedEbaySiteId: state.selectedEbaySiteId,
      }),
    }
  )
);
